import React from 'react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { comedores } from '../../utils/data';
import HomeCard from '../../components/homecard/homecard';
import { useNavigate } from 'react-router-dom';
import { ArticleNavBar } from '../article/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { verify } from '../../utils/common';

const DiningRooms: React.FC = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    
    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    };

    const renderComedores = () => {
        return comedores.map((item) => (
            <HomeCard data={item} handleClick={handleCardClick}/>
        ));
    };

    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [navigate]);
    
    return(
        <Box>
            <ArticleNavBar theme={theme}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBackIcon/>
                </IconButton>
            </ArticleNavBar>
            <Box m={5}>
                <Typography variant="h5">
                    Menú de comedores
                </Typography>
                <Box>
                    <Box>
                        {renderComedores()}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default DiningRooms;